import routes from './routes';
import { SetRoutes } from 'components';

const CandidatesAutoPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default CandidatesAutoPages;
